import { ApiClient } from '@dozuki/web-js/utils';
import { QueryClient, useQuery } from '@tanstack/react-query';
import { useLocalization } from '~/framework';
import {
   getTeamMembersFromClient,
   getTeamMembers,
   GetTeamMembersErrorCode,
} from '~/pages/api/teams/getTeamMembers.api';
import { useApiErrorMessageToast } from '~/pages/_shared';

const KEY = 'team_members';

export function useTeamMembers(teamid: number | null) {
   const { _js } = useLocalization();
   const { handleErrorOrRedirectToLogin } = useApiErrorMessageToast<GetTeamMembersErrorCode>({
      'teams.team_members_not_found': _js('Could not find team members'),
      default: _js('There was a problem retrieving the team members; please try again'),
   });

   const queryFunction = async () => {
      if (!teamid) return null;
      return await getTeamMembersFromClient(teamid);
   };

   return useQuery({
      queryFn: queryFunction,
      queryKey: [KEY, teamid],
      onError: handleErrorOrRedirectToLogin,
   });
}

export async function prefetchTeamMembers(
   teamid: number,
   apiClient: ApiClient,
   queryClient: QueryClient
): Promise<void> {
   await queryClient.fetchQuery([KEY, teamid], () => getTeamMembers(teamid, { apiClient }));
}
